// Indirizzo aperto senza accesso da un link esterno (es. il task della mail): si riprende dopo il login.
// In sessionStorage resta anche dopo il giro di redirect del login Azure.
const INITIAL_URL_KEY = 'initialUrl';
const AUTH_PATHS = ['', '/', '/login', '/auth/callback'];

export function saveInitialUrl(url: string): void {
  if (!AUTH_PATHS.includes(url.split('?')[0])) {
    sessionStorage.setItem(INITIAL_URL_KEY, url);
  }
}

export function readInitialUrl(): string | null {
  return sessionStorage.getItem(INITIAL_URL_KEY);
}

export function clearInitialUrl(): void {
  sessionStorage.removeItem(INITIAL_URL_KEY);
}
